import axios from 'axios';

/** Descarga un archivo de un endpoint autenticado y lo guarda en el equipo. */
export async function downloadAuthedFile(url, fallbackName) {
  const token = localStorage.getItem('token');
  const res = await axios.get(url, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: 'blob',
  });
  const disposition = res.headers['content-disposition'] || '';
  const match = disposition.match(/filename="?([^";]+)"?/);
  const name = match ? match[1] : fallbackName;
  const blobUrl = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement('a');
  link.href = blobUrl;
  link.setAttribute('download', name);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(blobUrl);
  return name;
}
